import router from "@/router";
import {
  signInUser,
  getUsers,
  signOutUser,
  getCurrentUser,
  getCurrentUserIdToken,
} from "@/services";
import $paths from "@/constants/route-paths";
import { getUserTimezone } from "@/utils/common.utils";

/**
 * Module state
 */
const state = {
  currentUser: null,
  isLoggedIn: false,
  currentUserProfile: null,
};

/**
 * Mutations constants
 */

const SET_CURRENT_USER = "SET_CURRENT_USER";
const LOG_OUT_USER = "LOG_OUT_USER";
const SET_USER_PROFILE = "SET_USER_PROFILE";

/**
 * Mutations
 */
const mutations = {
  [SET_CURRENT_USER](state, data) {
    state.isLoggedIn = true;
    state.currentUser = data;
  },
  [LOG_OUT_USER](state) {
    state.isLoggedIn = false;
    state.currentUser = null;
    state.currentUserProfile = null;
  },
  [SET_USER_PROFILE](state, data) {
    state.currentUserProfile = data;
  },
};

/**
 * Actions
 */
const actions = {
  /**
   * Sends an ajax request to authorise the user on the basis of the credentials
   * commits a mutation to save the user details in the store
   * @param {Object} credentials User credentials who wants to login
   */
  async signInUser({ commit }, credentials) {
    try {
      let { user } = await signInUser(credentials);

      const token = await getCurrentUserIdToken();
      const userDetails = await getCurrentUser();

      const { displayName, photoURL, phoneNumber } = userDetails;
      const details = { displayName, photoURL, phoneNumber };

      const { email, expiresIn, refreshToken, uid } = user;
      user = { email, expiresIn, refreshToken, token, uid, ...details };

      commit(SET_CURRENT_USER, user);
      // await dispatch("getUserProfile", { email });

      /**
       * @todo Change path to $paths.dashboard once dashboard view have been implemented
       */
      router.push({ path: $paths.customers });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  /**
   * Fetches user profile details from the user api resource
   * @param {Object} params
   */
  async getUserProfile({ commit }, params = null) {
    try {
      let { data } = await getUsers(params);

      data = data ? data[0] : {};
      commit(SET_USER_PROFILE, data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  /**
   * logoutUser
   * @description Logouts the logged in user
   */
  async logoutUser({ commit }) {
    await signOutUser();
    await commit(LOG_OUT_USER);

    router.replace($paths.loggedOut);
  },
};

/**
 * Getters
 */
const getters = {
  isLoggedIn({ isLoggedIn }) {
    return isLoggedIn;
  },
  token({ currentUser }) {
    return currentUser?.token ?? "";
  },
  currentUserProfile({ currentUserProfile }) {
    return currentUserProfile;
  },
  timezone({ currentUserProfile }) {
    return currentUserProfile?.time_zone ?? getUserTimezone();
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
